import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Logo from "../../Assets/writeme.png";
import Spinner from "../../Components/Spinner/Spinner";
import { toast } from "react-toastify";
import axios from "axios";
import baseUrl from "../../baseUrl";

const Signin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleSignin = (e) => {
    e.preventDefault();

    if (!email || !password) {
      toast.error("Please fill all the fields");
    } else {
      setLoading(true);
      axios
        .post(`${baseUrl}/user/signin`, { email, password })
        .then((response) => {
          if (response.data.success === true) {
            localStorage.setItem(
              "WM:user-token",
              JSON.stringify(response.data.token)
            );
            localStorage.removeItem("user-token");
            toast.success(response.data.message);
            navigate("/");
            window.location.reload();
          } else {
            toast.error(response.data.message);
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => setLoading(false));
    }
  };
  return (
    <>
      {loading && <Spinner />}
      <div className="min-h-screen flex justify-center items-center">
        <form
          onSubmit={handleSignin}
          className="py-12 px-12 bg-gray-200 rounded-2xl shadow-xl z-20"
        >
          <div className="flex flex-col">
            <Link to="/">
              <img
                src={Logo}
                className="align-middle mx-auto"
                width="70px"
                height="70px"
                alt="logo"
                draggable="false"
              />
            </Link>
            <h1 className="text-3xl capitalize font-bold text-center mb-4 ">
              Sign In to your account
            </h1>
          </div>
          <div className="space-y-4">
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Email Address"
              className="block text-sm py-3 px-4 rounded-lg w-full border outline-none"
              required
            />
            <input
              type="password"
              placeholder="Password"
              name="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="block text-sm py-3 px-4 rounded-lg w-full border outline-none"
              required
            />
          </div>
          <div className="text-center mt-6">
            <button className="py-3 w-64 text-xl text-white bg-cyan-500 rounded-2xl">
              {loading ? "Signing in..." : "Sign In"}
            </button>
            <p className="mt-4 text-sm">
              Don't have an account yet?
              <span className="underline cursor-pointer ml-2">
                <Link to="/signup">Sign Up</Link>
              </span>
            </p>
          </div>
        </form>
      </div>
    </>
  );
};

export default Signin;
